import { computed, nextTick, onMounted, unref, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { loadLoginSDK } from '@/util/txsdk'
import { wxOpenAppId } from '@/util/env'

export function useWechatOpenQr({ containerId, redirectUriRef, oauthStateRef }) {
  const wechatLoginConfigured = computed(() => Boolean(wxOpenAppId && unref(redirectUriRef)?.trim?.()))

  function resolveOAuthState() {
    const external = unref(oauthStateRef)
    const s = typeof external === 'string' ? external.trim() : ''
    return s
  }

  function renderWechatQr() {
    if (!wechatLoginConfigured.value) return

    const state = resolveOAuthState()
    if (!state) return

    const el = document.getElementById(containerId)
    if (!el) return

    const redirectUri = unref(redirectUriRef)?.trim?.()
    if (!redirectUri) return

    el.innerHTML = ''
    loadLoginSDK()
      .then((WxLogin) => {
        new WxLogin({
          self_redirect: false,
          id: containerId,
          appid: wxOpenAppId,
          scope: 'snsapi_login',
          redirect_uri: encodeURIComponent(redirectUri),
          state,
          style: 'black',
          fast_login: true
        })
      })
      .catch((e) => {
        console.error(e)
        ElMessage.error('加载微信登录失败')
      })
  }

  onMounted(() => {
    if (!wechatLoginConfigured.value) return
    nextTick(() => renderWechatQr())
  })

  watch(
    () => [unref(redirectUriRef), unref(oauthStateRef)],
    () => {
      if (!wechatLoginConfigured.value) return
      nextTick(() => renderWechatQr())
    }
  )

  return { wechatLoginConfigured, renderWechatQr }
}
